<script setup lang="js">
import { storeToRefs } from 'pinia';
import { useToastStore } from '@/stores/toast.store';

const toastStore = useToastStore();
const { toasts } = storeToRefs(toastStore);
</script>

<template>
  <div class="toast-stack" role="status" aria-live="polite">
    <TransitionGroup name="toast">
      <div v-for="toast in toasts" :key="toast.id" class="toast-item">
        <span class="toast-mark" />
        <span class="toast-text">{{ toast.text }}</span>
        <button type="button" class="toast-close" @click="toastStore.dismiss(toast.id)">
          &times;
        </button>
      </div>
    </TransitionGroup>
  </div>
</template>

<style scoped>
.toast-stack {
  position: fixed;
  left: 24px;
  bottom: 24px;
  z-index: 1100;
  display: flex;
  flex-direction: column;
  gap: 10px;
  pointer-events: none;
}

.toast-item {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 260px;
  max-width: 420px;
  padding: 12px 14px;
  border-radius: 8px;
  background: #1b1f2b;
  box-shadow: 0 10px 28px rgba(20, 24, 40, 0.28);
  pointer-events: auto;
}

/* Зелёная точка вместо иконки: в проекте нет набора статусных иконок,
   а точка читается и не тянет за собой новый ассет. */
.toast-mark {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #3ddc97;
  flex-shrink: 0;
}

.toast-text {
  flex: 1;
  font-size: 14px;
  line-height: 1.35;
  color: #f2f4f8;
}

.toast-close {
  border: 0;
  background: transparent;
  padding: 0 2px;
  font-size: 20px;
  line-height: 1;
  color: #7f8899;
  cursor: pointer;
}

.toast-close:hover {
  color: #f2f4f8;
}

.toast-enter-active,
.toast-leave-active {
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.toast-enter-from,
.toast-leave-to {
  opacity: 0;
  transform: translateX(-12px);
}

@media (prefers-reduced-motion: reduce) {
  .toast-enter-active,
  .toast-leave-active {
    transition: none;
  }
}
</style>
